export const localeToMarketCode = (locale = ''): string => {
  if (!locale || locale === 'default' || !Intl.Locale) {
    return 'se'
  }
  return new Intl.Locale(locale)?.region?.toLowerCase()
}

export default localeToMarketCode
